var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5v22h24V5Zm2 2h20v2H6Zm0 4h20v14H6Zm3 2v2h14v-2Zm0 4v2h2v-2Zm4 0v2h10v-2Zm-4 4v2h2v-2Zm4 0v2h10v-2Z"
  })));
};
export default SvgList;